import React, { useEffect, useState, useMemo } from 'react';
import DateRangeSelector from '../DateRangeSelector/DateRangeSelector.jsx';
import styles from './CampaignDetails.module.css';
import CountryCampaignView from './CountryCampaignView.jsx';
import OrderService from '../../../services/orderService';
import { useLoading } from '../Contexts/LoadingContext';
import QueryStringService from '../../../services/queryStringService.js';
import { PRODUCT_TYPES, CAMPAING_PROMISE_TYPES } from '../../../constants/enums';
import CountryInfoBox from './CountryInfoBox.jsx';

const CampaignDetails = ({ customerId, orderlinesData: initialOrderlinesData, orderData, selectedOrderlineIds,
    campaignType, campaignPromiseType, parameters }) => {
    const [selectedDates, setSelectedDates] = useState({ startDate: null, endDate: null });
    // full unfiltered dataset retained from initial prop
    const [orderlinesData, setOrderlinesData] = useState(initialOrderlinesData);
    // filtered dataset only for InfoBoxes (date range filtering)
    const [filteredOrderlinesData, setFilteredOrderlinesData] = useState(null);
    const [orderOrderLines, setOrderOrderLines] = useState(null);
    const [postingData, setPostingData] = useState(null);
    const orderService = useMemo(() => new OrderService(), []);
    const queryStringService = useMemo(() => new QueryStringService(), []);
    const { setIsLoading, isLoading } = useLoading();
    const country = queryStringService.getCurrentCountry();
    const showDaysGraph = campaignType === PRODUCT_TYPES.PLAY && campaignPromiseType.toLowerCase() !== CAMPAING_PROMISE_TYPES.DK_DIGITAL_SOV;

    useEffect(() => {
        if (campaignType === PRODUCT_TYPES.CLASSIC) { 
            const mergedData = [
                ...initialOrderlinesData.postingData,
                ...initialOrderlinesData.podPostingData,
            ];

            const sortedPostingData = mergedData.sort((a, b) => {
                const dateA = new Date(a.postingDate);
                const dateB = new Date(b.postingDate);
                return dateA - dateB;
            });
            setPostingData(sortedPostingData);
        }
    }, [initialOrderlinesData]);

    

    const handleDateChange = (startDate, endDate) => {
        setSelectedDates({ startDate, endDate });
    };

    useEffect(() => {
        const orderlines = orderData.orderLines.filter(orderline =>
            selectedOrderlineIds.includes(Number(orderline.id))
        );
        setOrderOrderLines(orderlines);
    }, [orderData, selectedOrderlineIds]);


    useEffect(() => {
        const orderlines = orderData.orderLines.filter(orderline =>
            selectedOrderlineIds.includes(Number(orderline.id))
        );
        if ((selectedDates.startDate || selectedDates.endDate)) {
            setIsLoading(true);
            orderService.getOrderLines(
                customerId,
                orderlines,
                selectedDates.startDate,
                selectedDates.endDate,
                country,
                (data) => {
                    if (data) {
                        // only update filtered dataset, keep full dataset intact
                        setFilteredOrderlinesData(data);
                    }
                    setIsLoading(false);
                },
                () => {
                    console.error("Error fetching order lines.");
                    setIsLoading(false);
                }
            );
        }
    }, [selectedDates, orderData, selectedOrderlineIds, country, customerId, orderService, setIsLoading]);

    return (
        <div className={styles.container}>
            <div className={styles.leftCol}>
                <DateRangeSelector
                    country={country}
                    classicPostings={postingData}
                    productType={campaignType}
                    defaultStart={orderOrderLines ? orderOrderLines[0].periodStart : null}
                    defaultEnd={orderOrderLines ? orderOrderLines[0].periodEnd : null}
                    className={styles.dateRangeSelector} 
                    onDateChange={handleDateChange} />
                <CountryInfoBox
                    country={country}
                    orderOrderLines={orderOrderLines}
                    initialOrderlinesData={initialOrderlinesData}
                    infoBoxData={filteredOrderlinesData || orderlinesData}
                    orderData={orderData}
                    campaignPromiseType={campaignPromiseType}
                    campaignType={campaignType}
                    parameters={parameters}
                />
            </div>
            <div className={styles.rightCol}>
                <CountryCampaignView
                    country={country}
                    originalOrderlinesData={orderlinesData}
                    filteredOrderlinesData={filteredOrderlinesData || orderlinesData}
                    campaignPromiseType={campaignPromiseType}
                    campaignType={campaignType}
                    showDaysGraph={showDaysGraph}
                    isLoading={isLoading}
                    orderOrderLines={orderOrderLines}
                />
            </div>
                
        </div>
    );
};

export default CampaignDetails;
